
const PoiLayer = L.Layer.extend({
    initialize: function(t) {
        this.className = t;
    },
    getPane: function() {
        return this._map.getPanes().markerPane
    },
    onAdd: function(t) {
        this._map = t;
        this.displayed = true;
        if( ! this._container ) {
            this._container = L.DomUtil.create("div", "leaflet-layer windy-pois pois-".concat(this.className));
        }
        this.getPane().appendChild(this._container);
        this._map.on("viewreset", this._reset, this);
        this._map.on("zoomend", this._reset, this);
        this._reset();
        this._markers = {};

        return this;
    },
    getHtml: function(t, o, element) {
        const html = element.html
            , s = void 0 === html ? "" : html
            , style = element.style
            , a = void 0 === style ? "" : style
            , p = element.attrs
            , r = void 0 === p ? [] : p
            , l = this._map.latLngToLayerPoint(o);

        return '<div data-id="'.concat(t, '" class="poi-point"\n                    data-lat="').concat(o.lat, '" data-lon="').concat(o.lng, '"\n                    style="transform: translate(').concat(l.x, "px, ").concat(l.y, "px); ").concat(a, '"\n                    ').concat(r ? r.join(" ") : "", ">").concat(s, "</div>")
    },
    addPois: function(t, o) {
        if (this._container)
            this._container.insertAdjacentHTML("beforeend", t);
        this._markers = o;
    },
    removePois: function() {
        if(this._container)
            this._container.innerHTML = "";
    },
    onRemove: function() {
        if(this._container)
            this.getPane().removeChild(this._container);
        this.displayed = false;
        this._map.off("viewreset", this._reset, this);

        return this;
    },
    replaceMarker: function(t, o) {
        let container = this._container, element;

        if (null === container || void 0 === container)
            element = void 0;
        else
            element = container.querySelector('[data-id="'.concat(t, '"]'));

        if (element)
            element.outerHTML = o;
    },
    getAllMarkers: function() {
        let t, container = this._container;

        if(null === container || void 0 === container)
            t = void 0;
        else
            t = container.querySelectorAll("[data-id]");

        if (null !== t && void 0 !== t)
            return t;
        else
            return [];
    },
    _reset: function() {
        if (this._map)
            this.forAllMarkers(this.getPosReset.bind(this));
    },
    forAllMarkers: function(t) {
        let o, i, e = this.getAllMarkers(), s = e.length;
        for (let n = 0; n < s; n++) {
            o = e[n];
            if(this._markers && o.dataset.id && o.dataset.id in this._markers) {
                i = t(this._markers[o.dataset.id]);
                this.setPoistion(o, i)
            }
        }
    },
    getPosReset: function(t) {
        return this._map.latLngToLayerPoint(t)
    },
    setPoistion: function(t, o) {
        t.style.transform = "translate(".concat(o.x, "px, ").concat(o.y, "px)");
    }
})


export default PoiLayer;
